import React, {useState,useEffect} from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col,Row, Modal, ModalHeader,Button,Alert } from "reactstrap"

import profileImg from "../../../../assets/images/profile-img.png"
import defaultImg from "../../../../assets/images/defaultuserimgdark.png"

import axios from 'axios';
const baseUrl = process.env.REACT_APP_BASE_URL;

const Settings: React.FC = () => {
  const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
  const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
      if (reason === "clickaway") { return; } 
      setAlertMsgg({ ...alertMsgg, open: false }) 
  };
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [packages, setPackages] = useState<any>([]);
  const [modal_center, setmodal_center] = useState(false);



const [managepack, setManagePack] = useState(false);
// const [selectedPack, setSelectedPack] = useState();
// const [selectedPack, setSelectedPack] = useState<typeof packages[0] | null>(null);
const [selectedPack, setSelectedPack] = useState<Package | null>(null);
const [switchType, setSwitchType] = useState<"Upgrade" | "Downgrade" | null>(null);
const [adjustedAmount, setAdjustedAmount] = useState<number | null>(null);


interface Package {
  id: number;
  name: string;
  price: number;
}


  function booknow() { //SUBSCRIPTION MODAL FUNCTION
    setmodal_center(!modal_center);
    document.body.classList.add("no_padding");
  } 

  const [showloader, setshowloader] = useState(true);

  
  const bookSubscription = (packId: number) => {
    handleStripeclick(packId);
  };
  const handleStripeclick = async (packId: number) => {
    const user_role = localStorage.getItem('userole_')
    
    if (isSubmitting) return;
      setIsSubmitting(true);
      try {
        setshowloader(true)
        const response = await axios.post('payments/create_subscription_checkout',{user_selected_pack:packId,user_role:user_role},{withCredentials:true,headers: {
          "Content-Type": "application/json",
        },});
        
        if (response.status === 'chekout_stripe' && response.success_url){
          console.log('Success stripe payment - redirecting to checkout')
          setAlertMsgg({ ...alertMsgg, open: true, content:`Redirecting you for subscription payment.`, type:"success" })
          setTimeout(() => { setAlertMsgg(prev => ({ ...prev, open: false })); }, 3000);
          setTimeout(()=>{
            window.location.href = response.success_url;
            setshowloader(false)
          }, 3500)
        }
        else if (response.status === 'subscription_updated'){
          setAlertMsgg({ ...alertMsgg, open: true, content:`Please Wait. While we update the package.`, type:"success" })
          setTimeout(() => {setAlertMsgg(prev => ({...prev,open: false}));}, 7000);
          setTimeout(() => {
            setmodal_center(false);
            setshowloader(false)
          }, 8000);
          if (response.cstpack) {
            localStorage.removeItem('cstpack')
            localStorage.setItem('cstpack',JSON.stringify(response.cstpack))
          }
          window.dispatchEvent(new Event("refreshProfile"));
          setTimeout(() => {
            setAlertMsgg({ ...alertMsgg, open: true, content:`Your subscription has been successfully updated.`, type:"success" })
            setTimeout(() => {setAlertMsgg(prev => ({...prev,open: false}));}, 5000);
          }, 8000);
        } else {
          console.log('Unexpected response status:', response.status)
          setshowloader(false)
          setIsSubmitting(false)
        }
        // alert("User status changed successfully!");
      } catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
              console.log('Error in stripe payment')
              setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
            }
            else if (error.response.status === 403) {
              console.log('Error stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
              console.log('An error occurred')
              setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
            }
        } else {
          console.log('An error occurred')
          setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
        }
        setshowloader(false)
  } finally {
        setIsSubmitting(false); // Re-enable button
    }
  }


  const fetch_experts = async () => {
      try {
        setshowloader(true)
        const response = await axios.post(`accounts/get_experts`, {withCredentials: true, headers: { 'Content-Type': 'application/json'}} );
        if (response.status === "SENT") {
          const packageData = response.packs.map((item: any) => ({
            id: item.id,
            name: item.name,
            price: item.price,
            description: item.description,
            features: item.features,
            mpopular: item.mpopular,
            // features: item.features.feature
          }));
          setPackages(packageData);
          setTimeout(()=>{setshowloader(false)}, 1200)
        }
      } catch (error:any) {
        console.log('REACHED IN CATCH')
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
              console.log('Error in stripe payment')
              setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
            }
            else if (error.response.status === 403) {
              console.log('Error stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
              console.log('An error occurred')
              setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
            }
        } else {
          console.log('An error occurred')
          setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
        }
        // setshowloader(false)
    }            
  };

  // Fetch customer profile to refresh subscription status
  const fetchCustomerProfile = async () => {
    try {
      const response = await axios.post('accounts/get_customer', {}, { withCredentials: true });
      if (response.status === "SENT" && response.userprofile?.cstpack) {
        // Update localStorage with fresh subscription data
        localStorage.setItem('cstpack', JSON.stringify(response.userprofile.cstpack));
        console.log('Customer profile refreshed in Settings, subscription status updated');
        // Force re-render by updating a state or triggering refresh
        window.dispatchEvent(new Event("refreshProfile"));
      }
    } catch (error: any) {
      console.error("Error fetching customer profile:", error);
    }
  };

  useEffect(() => {   
    fetch_experts();
    // Fetch customer profile on mount to refresh subscription status
    if (localStorage.getItem('userole_') === "cst") {
      fetchCustomerProfile();
    }
    window.addEventListener("refreshProfile", fetch_experts);
    return () => window.removeEventListener("refreshProfile", fetch_experts); 
  }, []);

  interface UserData {
    id: string;
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    get_full_name: string;
    role: string;
    profile_pic: string;

    active: boolean;
    name: string;
    price: string;
    description: string;
    sub_type: string;
  }

  interface UserDataNew {
    active: boolean;
    name: string;
    price: string;
    description: string;
    sub_type: string;
    is_trial: string;
    trial_days: string;
    period_start: string;
    period_end: string;
    invoice_amount:string;
    invoice_date:string;
  }




  const userDataString = localStorage.getItem("userdata");
  let userData: UserData | null = null;
  if(userDataString){
    try{
      userData = JSON.parse(userDataString);
    }catch(error){
      console.error('Invalid JSON in localstorage',error);
    }
  }

  const userpackdatastring = localStorage.getItem("cstpack");
  let userPackData: UserDataNew | null = null;
  if(userpackdatastring){
    console.log("userPackData---2222")
    try{
      userPackData = JSON.parse(userpackdatastring);
      if (userPackData && typeof userPackData.active === "string") {
        userPackData.active = userPackData.active === "true";
      }
    
      console.log("userPackData-333--",userPackData)
    }catch(error){
      console.error('Invalid JSON in localstorage',error);
    }
  }


 
  return (
    <React.Fragment>
      {alertMsgg.open && (
        <Alert 
          color={alertMsgg.type === "success" ? "success" : "danger"} 
          toggle={handleAlertMsggClose}
          style={{ fontWeight: "bold" }}
        >
          {alertMsgg.content}
        </Alert>
      )}
      <Col lg={4} className="order-lg-2 order-1">

      <Card className="overflow-hidden rounded-4 mb-5">
        <div className="bg-primary-subtle bgImgGradient">
          <Row>
            <Col xs={7}>
              <div className="text-dark p-3">
                <h5 className="text-dark">Welcome Back !</h5>
                <p>BizServe Dashboard</p>
              </div>
            </Col>
            <Col xs={5} className="align-self-end">
              <img src={profileImg} alt="" className="img-fluid" />
            </Col>
          </Row>
        </div>
        <CardBody className="pt-0">
          <Row>
            <Col sm={12}>
              <div className="floatUsertag">
                <Link to="/cprofile" className="btn btn-primary  btn-sm">
                  View Profile <i className="mdi mdi-arrow-right ms-1"></i>
                </Link>
              </div>
              <div className="avatar-md profile-user-wid dash-profile mb-4">
                <img
                  src={userData?.profile_pic || defaultImg}
                  alt=""
                  className="img-thumbnail rounded-circle"
                />
              </div>
              <h5 className="font-size-15 text-dark">{userData?.get_full_name} <span className="badge badge-soft-primary">Customer</span></h5>
              <p className="text-muted mb-0 text-truncate font-size-14 d-flex align-items-center gap-2 mb-1">
                <i className="bx bx-envelope"></i>{userData?.email}</p>
              <p className="text-muted mb-0 text-truncate font-size-14 d-flex align-items-center gap-2 mb-1">
                <i className="bx bxs-phone-call"></i> {userData?.phone}</p>
              <p className="text-muted mb-0 text-truncate font-size-14 d-flex align-items-center gap-2 mb-1">
                <i className="bx bxs-phone-call"></i> Customer ID - {userData?.id}</p>
            </Col>
          </Row>
        </CardBody>
      </Card>
      {userPackData?.active === true ? (
        
        <Card className="activePlan rounded-4">
          <CardBody>
          <span className="badge bg-primary rounded-5 font-size-12 activeplanTag px-2 py-1">
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="me-1 startTag e-font-icon-svg e-fas-asterisk" viewBox="0 0 512 512"><path d="M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"></path></svg>
            Active Plan</span>
            <div className="text-white py-2">
                <p className="mb-1">{userPackData?.name}</p>
                <h1 className="font-size-25">${userPackData?.price}<span className="font-size-10">/month</span></h1>
                {userPackData?.is_trial ? (<p>Hey there! BizServe's got you covered — enjoy {userPackData?.trial_days} days free on us! After that, regular pricing kicks in.</p>) : null}
                <p className="mb-1">Period: {userPackData?.period_start} to {userPackData?.period_end}</p>
                {Number(userPackData?.invoice_amount) > 0 && (
                  <p className="mb-1">
                    Upcoming Invoice : ${userPackData?.invoice_amount}/month on {userPackData?.invoice_date}
                  </p>
                )}

            </div>
          </CardBody>
          <Button onClick={() => {booknow();}} color="primary" className="btn">Switch Plan</Button>
            <Modal
              isOpen={modal_center}
              toggle={() => {
                booknow();
              }}
              centered
              size="xl"
              className="rounded-4">
              <ModalHeader className="py-3 px-4" toggle={() => {
                booknow();
              }}>
                <div className="modal-title mt-0 font-size-20 text-dark">Switch plan</div>
              </ModalHeader>
              <div className="modal-body p-4">
                <p className="font-size-15 mb-1">Before Booking an expert, please subscribe to a monthly plan from the options below.part 3</p>
                <p className="font-size-15">Switching plans will automatically cancel your current subscription.</p>


                <div className="position-relative overflow-hidden">
                  <div className="loaderContainerdiv" hidden={!showloader}>
                    <div className="spinner">
                      <div></div>  
                      <div></div>    
                      <div></div>    
                      <div></div>    
                      <div></div>    
                      <div></div>    
                      <div></div>    
                      <div></div>    
                      <div></div>    
                      <div></div>    
                    </div>
                  </div>
                  <Row className="mt-4">
                    {packages.length > 0 && packages.map((pack) => {
                      const colSize = packages.length >= 3 ? 4 : packages.length === 2 ? 6 : 12;
                      const cstpack = JSON.parse(localStorage.getItem("cstpack") || "{}");
                      const isCurrentPack = cstpack?.name === pack.name;
                      const BuyButtonText = (cstpack && Object.keys(cstpack).length > 0 && (cstpack?.active))
                                              ? (isCurrentPack)    
                                                ? "Active Plan" 
                                                : (cstpack?.is_trial || (Number(cstpack?.price) === pack.price))
                                                  ? `Switch to ${pack.name}` 
                                                  : `${(Number(cstpack?.price) < pack.price) ? "Upgrade" : "Downgrade"} to ${pack.name}`
                                              : `Start with ${pack.name}`
                      

                      return (
                        <Col md={colSize} key={pack.id} className={pack.mpopular ? "mpopular mb-4" : "mb-4"}>
                          <Card className="rounded-4 border border-dark h-100 ">
                            <CardBody>
                              {pack.mpopular && (
                                <span className="badge bg-primary rounded-5 font-size-12 activeplanTag px-2 py-1">
                                  {/* SVG omitted for brevity */}
                                  Most Popular
                                </span>
                              )}
                              <div className="text-dark py-2">
                                <p className={pack.mpopular ? "mb-3 font-size-15 fw-medium text-white" : "mb-3 font-size-15 fw-medium text-secondary"}>
                                  {pack.name}
                                  {isCurrentPack && <span className="badge bg-success ms-2">Current</span>}
                                </p>
                                <h1 className={pack.mpopular ? "text-white font-size-25" : "font-size-25 text-secondary"}>
                                  ${pack.price.toFixed(2)}
                                  <span className={pack.mpopular ? "text-white font-size-10" : "font-size-10"}>/month</span>
                                </h1>
                                <p className={pack.mpopular ? "text-white fw-thin font-size-13" : "font-size-13 text-dark"}>
                                  {pack.description}
                                </p>
                              </div>
                              <div className="d-grid gap-2">
                                <Button
                                  type="button"
                                  className={pack.mpopular ? "bg-white text-dark fw-medium" : "btn bg-primary btn-md border-0"}
                                  // onClick={() => bookSubscription(pack.id)}
                                  onClick={() => {
                                    const actionType =
                                      Number(cstpack?.price) < pack.price ? "Upgrade" :
                                      Number(cstpack?.price) > pack.price ? "Downgrade" :
                                      null;

                                    const priceDifference = Math.abs(Number(cstpack?.price) - pack.price);
                                    setSelectedPack(pack);
                                    setSwitchType(actionType);
                                    setAdjustedAmount(priceDifference);
                                    setManagePack(true);   // open modal
                                  }}
                                  disabled={isCurrentPack}
                                >
                                  {BuyButtonText}
                                </Button>
                              </div>
                  
                              <div className="mt-4">
                                <p className={pack.mpopular ? "text-white mb-2 font-size-14 fw-medium" : "mb-2 font-size-14 fw-medium text-muted"}>Features</p>
                                <ul className={pack.mpopular ? "text-white font-size-14 text-dark ps-0 list-style-none starStyleList" : "font-size-14 text-dark ps-0 list-style-none starStyleList"}>
                                  {pack.features.map((item: any, index: number) => (
                                    <li key={index} className="mb-1 font-size-13">
                                      {/* SVG omitted for brevity */}
                                      {item.feature}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      );
                    })}
                  </Row>
                 
                    {selectedPack && (
                      <Modal isOpen={managepack} centered toggle={() => setManagePack(!managepack)}>
                        <ModalHeader toggle={() => setManagePack(!managepack)}>
                          <div className="h5 modal-title">{selectedPack.name}</div>
                        </ModalHeader>
                        <div className="modal-body">
                        {switchType === "Upgrade" && (
                          <p> The remaining payment amount will be billed in your upcoming invoice after the upgrade. </p>
                        )}
                        {switchType === "Downgrade" && (
                          <p>The balance from your current plan (if any) will be carried forward and adjusted in your upcoming invoice after the downgrade.</p>
                        )}
                        {!switchType && (
                          <p>Are you sure you want to switch to new Package.</p>
                        )}
                      </div>
                        <div className="modal-footer">
                          <button type="button" className="btn btn-soft-dark" onClick={() => setManagePack(false)}>
                            Cancel
                          </button>
                          <button type="button" className="btn btn-danger" onClick={() => {
                              bookSubscription(selectedPack.id);
                              setManagePack(false);
                            }}>
                             {switchType ?  switchType : "Done" }
                          </button>
                        </div>
                      </Modal>
                    )}
                </div>

              </div>
            </Modal>

        </Card>
      ): false && userPackData?.active === false ? ( // FREE_PLATFORM_MODE: Hide expired message. To restore: userPackData?.active === false ? (
        <Card v-else-if="{userData?.active === false}" className="activePlan rounded-4">
          <CardBody>
          <span className="badge bg-primary rounded-5 font-size-12 activeplanTag px-2 py-1">
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="me-1 startTag e-font-icon-svg e-fas-asterisk" viewBox="0 0 512 512"><path d="M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"></path></svg>
          Package Expire</span>
            <div className="text-white py-2">
                <i className="bx bx-search-alt font-size-20"></i>
                <p className="mb-1 font-size-14">Your current package has expired and some features are temporarily unavailable. </p>
                <p className="font-size-11">
                To continue enjoying our full range of services, please renew your subscription or select a new plan.
                Renew now and get back on track!
                </p>
                
            </div>

            <Button onClick={() => {booknow();}} color="primary" className="btn">Renew Subscription</Button>
            <Modal
              isOpen={modal_center}
              toggle={() => {
                booknow();
              }}
              centered
              size="xl"
              className="rounded-4">
              <ModalHeader className="py-3 px-4" toggle={() => {
                booknow();
              }}>
                <div className="modal-title mt-0 font-size-20 text-dark">Subscribe</div>
              </ModalHeader>
              <div className="modal-body p-4">
                <p className="font-size-15 mb-1">Before Booking an expert, please subscribe to a monthly plan from the options below.</p>
                <p className="font-size-15">We appreciate your time and support!</p>
                <Row className="mt-4">
                {packages.length > 0 && packages.map((pack) => {
                const colSize = packages.length >= 3 ? 4 : packages.length === 2 ? 6 : 12;

                  return (
                    <Col md={colSize} key={pack.id} className={pack.mpopular ? "mpopular mb-4" : "mb-4"}>
                      <Card className="rounded-4 border border-dark h-100 ">
                        <CardBody>
                          {pack.mpopular && (
                            <span className="badge bg-primary rounded-5 font-size-12 activeplanTag px-2 py-1"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="me-1 startTag e-font-icon-svg e-fas-asterisk" viewBox="0 0 512 512"><path d="M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"></path></svg>Most Popular</span>
                          )}
                          <div className="text-dark py-2">
                              <p className={pack.mpopular ? "mb-3 font-size-15 fw-medium text-white" : "mb-3 font-size-15 fw-medium text-secondary"}>{pack.name}</p>
                              <h1 className={pack.mpopular ? "text-white font-size-25" : "font-size-25 text-secondary"}>${pack.price.toFixed(2)}<span className={pack.mpopular ? "text-white font-size-10" : "font-size-10"}>/month</span></h1>
                              <p className={pack.mpopular ? "text-white fw-thin font-size-13" : "font-size-13 text-dark"}>{pack.description}</p>
                          </div>
                          <div className="d-grid gap-2">
                          <Button
                            type="button"
                            className={pack.mpopular ? "bg-white text-dark fw-medium" : "btn bg-primary btn-md border-0"}
                            onClick={() => bookSubscription(pack.id)}  
                          >
                            Start with {pack.name}
                          </Button>
                        </div>

                          <div className="mt-4">
                            <p className={pack.mpopular ? "text-white mb-2 font-size-14 fw-medium" : "mb-2 font-size-14 fw-medium text-muted"}>Features</p>
                            <ul className={pack.mpopular ? "text-white font-size-14 text-dark ps-0 list-style-none starStyleList" : "font-size-14 text-dark ps-0 list-style-none starStyleList"}>
                            {pack.features.map((item: any, index: number) => (
                              <li key={index} className="mb-1 font-size-13"><svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M10.5 15.25C10.307 15.2353 10.1276 15.1455 9.99998 15L6.99998 12C6.93314 11.8601 6.91133 11.7029 6.93756 11.55C6.96379 11.3971 7.03676 11.2562 7.14643 11.1465C7.2561 11.0368 7.39707 10.9638 7.54993 10.9376C7.70279 10.9114 7.86003 10.9332 7.99998 11L10.47 13.47L19 5.00004C19.1399 4.9332 19.2972 4.91139 19.45 4.93762C19.6029 4.96385 19.7439 5.03682 19.8535 5.14649C19.9632 5.25616 20.0362 5.39713 20.0624 5.54999C20.0886 5.70286 20.0668 5.86009 20 6.00004L11 15C10.8724 15.1455 10.6929 15.2353 10.5 15.25Z" fill={pack.mpopular ? "#fff" : "#0a8543"}></path><path d="M12 21C10.3915 20.9974 8.813 20.5638 7.42891 19.7443C6.04481 18.9247 4.90566 17.7492 4.12999 16.34C3.54037 15.29 3.17596 14.1287 3.05999 12.93C2.87697 11.1721 3.2156 9.39921 4.03363 7.83249C4.85167 6.26578 6.1129 4.9746 7.65999 4.12003C8.71001 3.53041 9.87134 3.166 11.07 3.05003C12.2641 2.92157 13.4719 3.03725 14.62 3.39003C14.7224 3.4105 14.8195 3.45215 14.9049 3.51232C14.9903 3.57248 15.0622 3.64983 15.116 3.73941C15.1698 3.82898 15.2043 3.92881 15.2173 4.03249C15.2302 4.13616 15.2214 4.2414 15.1913 4.34146C15.1612 4.44152 15.1105 4.53419 15.0425 4.61352C14.9745 4.69286 14.8907 4.75712 14.7965 4.80217C14.7022 4.84723 14.5995 4.87209 14.4951 4.87516C14.3907 4.87824 14.2867 4.85946 14.19 4.82003C13.2186 4.52795 12.1987 4.43275 11.19 4.54003C10.193 4.64212 9.22694 4.94485 8.34999 5.43003C7.50512 5.89613 6.75813 6.52088 6.14999 7.27003C5.52385 8.03319 5.05628 8.91361 4.77467 9.85974C4.49307 10.8059 4.40308 11.7987 4.50999 12.78C4.61208 13.777 4.91482 14.7431 5.39999 15.62C5.86609 16.4649 6.49084 17.2119 7.23999 17.82C8.00315 18.4462 8.88357 18.9137 9.8297 19.1953C10.7758 19.4769 11.7686 19.5669 12.75 19.46C13.747 19.3579 14.713 19.0552 15.59 18.57C16.4349 18.1039 17.1818 17.4792 17.79 16.73C18.4161 15.9669 18.8837 15.0864 19.1653 14.1403C19.4469 13.1942 19.5369 12.2014 19.43 11.22C19.4201 11.1169 19.4307 11.0129 19.461 10.9139C19.4914 10.8149 19.5409 10.7228 19.6069 10.643C19.6728 10.5631 19.7538 10.497 19.8453 10.4485C19.9368 10.3999 20.0369 10.3699 20.14 10.36C20.2431 10.3502 20.3471 10.3607 20.4461 10.3911C20.5451 10.4214 20.6372 10.471 20.717 10.5369C20.7969 10.6028 20.863 10.6839 20.9115 10.7753C20.9601 10.8668 20.9901 10.9669 21 11.07C21.1821 12.829 20.842 14.6026 20.0221 16.1695C19.2022 17.7363 17.9389 19.0269 16.39 19.88C15.3288 20.4938 14.1495 20.8755 12.93 21C12.62 21 12.3 21 12 21Z" fill={pack.mpopular ? "#fff" : "#0a8543"}></path></svg> {item.feature} </li>))}
                            </ul>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  );
                })}
                </Row>

              </div>
            </Modal>
          </CardBody>
        </Card>
      ) : false ? ( // FREE_PLATFORM_MODE: Hide "No Active Subscription Found" message. To restore: remove "false ?" 
        <Card className="activePlan rounded-4">
          <CardBody>
          <span className="badge bg-primary rounded-5 font-size-12 activeplanTag px-2 py-1">
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="me-1 startTag e-font-icon-svg e-fas-asterisk" viewBox="0 0 512 512"><path d="M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"></path></svg>
            No Active Subscription Found</span>
            <div className="text-white py-2">
                <i className="bx bx-search-alt font-size-20"></i>
                <p className="mb-1 font-size-14">"No Active Subscription Found"</p>
                <p className="font-size-11">
                To unlock all features and enjoy uninterrupted access to our services, please choose a package that suits your needs and activate your plan.
                Upgrade now to get started!
                </p>
            </div>

            
          </CardBody>
        </Card>
      ) : null}

      </Col>
    </React.Fragment>
  )
}

export default Settings;
